import React, { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useUnidades } from "../../../hooks/test/useUnidades";
import { toast } from "react-toastify";
import { Spinner } from "../../Spinner";
import Swal from "sweetalert2";
import { SocketContext } from "../../../context/SocketContext";
import { Select as Select2 } from "../../Select";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocation } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../../../context/authContext/authContext";
import moment from "moment";
import "moment/locale/es-mx";

export const RegistrarEditarEventoRobo = ({ idUnidad, mostrarModal, onAction, tipo_unidad_id, eventAction, viajeId, evtBoletinado }) => {
    const [form, setForm] = useState({
        id_monitorista: "",
        monitorista: "",
        placas: "",
        serie: "",
        marca: "",
        color: "",
        evento_seguridad_id: "",
        evento_id: "",
        estatus_evento_id: "",
        operador: "",
        numero_operador: "",
        vialidad: "",
        coordenadas_inicio_evento: "",
        posicion_actual: "",
        estado: "",
        municipio: "",
        predenuncia: "",
        carpeta_investigacion: "",
        activacion_as3: "0",
        gps_reportando: false,
        activacion_as4: "0",
        chapas_seguridad: "0",
        cctv: "0",
        observaciones: "",
        modus_operandi: "",
        paro_motor: "0",
        nombre_evento: "",
        fecha_posicion_actual: "",
        coordenadas_fin_evento: "",
        predenuncia: "",
        cliente: "",
        cliente_name: "",
        clienteId: "",
        cliente_gestor: "",
        cliente_gestor_telefono: "",
        fecha_registro: "",
    });

    const {
        getEventos,
        getStatusEvento,
        getEntidadesFederativas,
        getMunicipiosId,
        postRegistroEventoSeguridad,
        postEventoSeguridad,
        getUnidadTipoId,
        getTipoApoyo,
        getExisteEventoRobo,
        putRegistroEventoSeguridad,
        postFilesUploads,
        deleteRegistroEventoSeguridad,
        patchRegistroSeguridad,
        postValidarArchivo,
    } = useUnidades();

    const { socket } = useContext(SocketContext);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [eventosRoboMotos, setEventosRoboMotos] = useState([]);
    const [eventosRoboAutos, setEventosRoboAutos] = useState([]);
    const [statusEventoAutos, setStatusEventoAutos] = useState([]);
    const [statusEventoMotos, setStatusEventoMotos] = useState([]);
    const [entidadesFederativas, setEntidadesFederativas] = useState([]);
    const [listMunicipios, setListMunicipios] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [tipoApoyo, setTipoApoyo] = useState([]);
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(new Date().toLocaleString("es-MX", "America/Mexico_City"));
    const [evt_seguridad_anteriores, setEvt_seguridad_anteriores] = useState(false);
    const timers = require('timers-promises');
    const { user, negocioSeleccionado } = useContext(AuthContext);

    const resetForm = () => {
        setForm({
            id_monitorista: "",
            monitorista: "",
            placas: "",
            serie: "",
            marca: "",
            color: "",
            evento_seguridad_id: "",
            evento_id: "",
            estatus_evento_id: "",
            operador: "",
            numero_operador: "",
            vialidad: "",
            coordenadas_inicio_evento: "",
            posicion_actual: "",
            estado: "",
            municipio: "",
            predenucia: "",
            carpeta_investigacion: "",
            activacion_as3: "0",
            gps_reportando: "0",
            activacion_as4: "0",
            chapas_seguridad: "0",
            cctv: "0",
            observaciones: "",
            modus_operandi: "",
            paro_motor: "0",
            nombre_evento: "",
            coordenadas_fin_evento: "",
            predenuncia: "",
            cliente: "",
            cliente_name: "",
            clienteId: "",
            cliente_gestor: "",
            cliente_gestor_telefono: "",
            fecha_registro: "",
        });
        setListMunicipios([]);
    };

    useEffect(async () => {
        await loadData();
    }, []);

    useEffect(() => {
        handleShow();
    }, [mostrarModal]);

    const handleChange = (event) => {
        setForm({ ...form, [event.target.name]: event.target.value });
    };

    const loadData = async () => {
        setLoading(true);
        let resp = await getEventos();
        if (resp.ok) {
            setEventosRoboMotos(resp.eventos.motos);
            setEventosRoboAutos(resp.eventos.autos);
        }

        let res = await getStatusEvento();
        if (res.ok) {
            setStatusEventoAutos(res.estatus.autos);
            setStatusEventoMotos(res.estatus.motos);
        }

        let re = await getEntidadesFederativas();
        if (re.ok) setEntidadesFederativas(re.entidades);

        let respue = await getTipoApoyo();
        if (respue.ok) setTipoApoyo(respue.tipos_apoyo);

        if (eventAction === "REGISTRAR") {
            setLoading(true);
            let r = await getUnidadTipoId(tipo_unidad_id, idUnidad);
            if (r.ok) {
                setLoading(false);
                if (r.localizacion) await getMunicipios(r.localizacion.entidad.id);
                if (r.eventos_seguridad_anteriores !== null) setEvt_seguridad_anteriores(r.eventos_seguridad_anteriores);
                setForm({
                    ...form,
                    placas: r.vehiculo.unidad_placas,
                    serie: r.vehiculo.unidad_vin,
                    marca: r.vehiculo.unidad_marca,
                    color: r.vehiculo.unidad_color,
                    posicion_actual: r.posicion_actual,
                    fecha_posicion_actual: r.fecha_posicion_actual,
                    cliente: r.vehiculo.cliente,
                    cliente_gestor: r.vehiculo.cliente_gestor,
                    cliente_gestor_telefono: r.vehiculo.cliente_gestor_telefono,
                    estado: r.localizacion && r.localizacion.entidad.id,
                    municipio: r.localizacion && r.localizacion.municipio.id,
                    vialidad: r.localizacion && r.localizacion.direccion,
                });
            } else {
                setLoading(false);
                Swal.fire({
                    title: "Error",
                    text: "Error al optener registros",
                    icon: "error",
                });
            }
        } else if (eventAction === "EDITAR") {
            let result = await getExisteEventoRobo(viajeId, 2);
            if (result.ok) {
                setForm({
                    ...form,
                    evento_seguridad_id: result.registro_seguridad.evento_seguridad_id,
                    id_monitorista: result.registro_seguridad.usuario ? result.registro_seguridad.usuario.id : "",
                    monitorista: result.registro_seguridad.usuario ? result.registro_seguridad.usuario.name : "",
                    evento_id: result.registro_seguridad.evento.evento_id,
                    nombre_evento: result.registro_seguridad.evento.evento,
                    placas: result.registro_seguridad.unidad.unidad_placas,
                    serie: result.registro_seguridad.unidad.unidad_vin,
                    marca: result.registro_seguridad.unidad.unidad_marca,
                    color: result.registro_seguridad.unidad.unidad_color,
                    estatus_evento_id: result.ultimo_evento_seguridad.estatus_evento_id,
                    posicion_actual: result.ultimo_evento_seguridad.coordenadas_online,
                    fecha_posicion_actual: result.ultimo_evento_seguridad.fecha_coordenadas_online,
                    cliente: result.registro_seguridad.unidad.cliente,
                    cliente_gestor: result.registro_seguridad.unidad.cliente_gestor,
                    cliente_gestor_telefono: result.registro_seguridad.unidad.cliente_gestor_telefono,
                    predenuncia:  result.registro_seguridad.predenuncia,
                    carpeta_investigacion: result.registro_seguridad.carpeta_investigacion,
                });

                if (result.eventos_seguridad_anteriores !== null) setEvt_seguridad_anteriores(result.eventos_seguridad_anteriores);
            }
        }
        setLoading(false);
    }

    const getMunicipios = async (Id) => {
        let resp = await getMunicipiosId(Id);
        if (!resp.ok) return;
        setListMunicipios(resp.municipios);
    };

    const registrarEventoRobo = async () => {
        let err = false;

        // validar datos de la unidad para envio completo de informacion
        if (form.placas === "" || form.serie === "" || form.marca  === "") {
            toast.error("¡Unidad con datos incompletos! favor de actualizarla", { position: toast.POSITION.BOTTOM_CENTER, });
            err = true;
        }

        if (form.cliente ==="" || form.cliente_gestor ==="" || form.cliente_gestor_telefono ==="" || form.color ==="") {
            toast.error("¡Unidad con datos incompletos! favor de actualizar datos", { position: toast.POSITION.BOTTOM_CENTER, });
            err = true;
        }
        // ./

        if (form.evento_id === "") {
            toast.error("Por favor selecciona un evento!", { position: toast.POSITION.BOTTOM_CENTER, });
            err = true;
        }

        if (form.estatus_evento_id === "") {
            toast.error("Por favor selecciona un estatus!", { position: toast.POSITION.BOTTOM_CENTER, });
            err = true;
        }

        if (form.coordenadas_inicio_evento === "") {
            toast.error("Por favor agrega las coordenadas de inicio de evento!", { position: toast.POSITION.BOTTOM_CENTER, });
            err = true;
        }

        if (form.municipio === "") {
            toast.error("Por favor agrega el municipio!", { position: toast.POSITION.BOTTOM_CENTER, });
            err = true;
        }

        if (form.estado === "") {
            toast.error("Por favor agrega el estado!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (form.estado === "") {
            toast.error("Por favor agrega el estado!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (err === false) {
            setLoading(true);

            let activacion_as3;
            let cctv;
            let paro_motor = form.paro_motor ? 1 : 0;
            if (tipo_unidad_id === 3) activacion_as3 = form.activacion_as4 ? "SI" : "NO";
            if (tipo_unidad_id === 4) {
                activacion_as3 = null;
                cctv = form.cctv ? 1 : 0;
            }

            let res = await postRegistroEventoSeguridad({
                "unidad_id": idUnidad,
                "tipo_unidad_id": tipo_unidad_id,
                "evento_id": form.evento_id,
                "municipio_id": form.municipio,
                "estado_id": form.estado,
                "coordenadas_inicio": form.coordenadas_inicio_evento,
                "predenuncia": form.predenuncia,
                "carpeta_investigacion": form.carpeta_investigacion,
                activacion_as3,
                "modus_operandi": form.modus_operandi,
                "vialidad": form.vialidad,
                cctv,
                paro_motor,
                "gps_reportando": form.gps_reportando,
            });

            if (res.ok) {
                let re = await postEventoSeguridad({
                    "evento_seguridad_id": res.evento_seguridad.evento_seguridad_id,
                    "estatus_evento_id": form.estatus_evento_id,
                    "fecha_hora": form.fecha_registro,
                    "coordenadas_online": form.posicion_actual,
                    "fecha_coordenadas_online": form.fecha_posicion_actual,
                    "observaciones": form.observaciones,
                });

                if (re.ok && (form.estatus_evento_id === 10 || form.estatus_evento_id === "10")) {
                    let resp = await deleteRegistroEventoSeguridad(res.evento_seguridad.evento_seguridad_id);
                    if (resp.ok) {
                        setLoading(false);
                        Swal.fire({
                            title: "REGISTRO DE EVENTO DE ROBO",
                            text: "Finalizado correctamente",
                            showConfirmButton: false,
                            icon: "success",
                            timer: 3000
                        });
                        handleClose();
                        resetForm();
                        setSelectedFile(null);
                        await timers.setTimeout(3000, 'result').then((res) => {
                            loadData();
                        });

                    } else {
                        setLoading(false);
                        Swal.fire({
                            title: "Error",
                            text: res.msg,
                            icon: "error",
                        });
                    }
                } else if (re.ok && form.estatus_evento_id !== 10){
                    setLoading(false);
                    Swal.fire({
                        title: "REGISTRO DE EVENTO DE ROBO",
                        text: "Guardado correctamente",
                        showConfirmButton: false,
                        icon: "success",
                        timer: 3000
                    });
                    
                    if(user.roles_id === 2) {
                        socket.emit("new_event_robo", { idNegocio: parseInt(negocioSeleccionado)});
                    } else {
                        socket.emit("new_event_robo", { idNegocio: user.negocio_id});
                    }

                    handleClose();
                    onAction();
                    resetForm();
                }
                else {
                    setLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: re.msg,
                        icon: "error",
                    });
                }
            } else {
                setLoading(false);
                console.log("error en registro-seguridad");
                Swal.fire({
                    title: "Error",
                    text: res.msg,
                    icon: "error",
                });
            }
        }
    }

    const handleFileUpload = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const actualizarEventoRobo = async () => {
        setLoading(true);
        let resp = false;
        let formData = new FormData();
        formData.append('archivo', selectedFile);
        let coordenadas_online;
        if (form.posicion_actual) coordenadas_online = form.posicion_actual;
        let fecha_posicion_actual;
        if (form.fecha_posicion_actual) fecha_posicion_actual = form.fecha_posicion_actual;

        if (evtBoletinado) {
            // reabriendo estatus de evento finalizado para meter nuevo seguimiento
            let re = await patchRegistroSeguridad(form.evento_seguridad_id);
            if (re) {
                resp = await postEventoSeguridad({
                    "evento_seguridad_id": form.evento_seguridad_id,
                    "estatus_evento_id": form.estatus_evento_id,
                    "apoyo_tipo_id": form.tipo_de_apoyo,
                    "fecha_hora": startDate,
                    "coordenadas": form.coordenadas_fin_evento,
                    coordenadas_online,
                    fecha_posicion_actual,
                    "lugar": form.lugar_remitido,
                    "observaciones": form.observaciones,
                });
            } else {
                setLoading(false);
                Swal.fire({
                    title: "Error",
                    text: re.msg,
                    icon: "error",
                });
            }
            
        } else {
            if (selectedFile !== null) {
                const validar = await postValidarArchivo(formData);
                if(!validar.ok){
                    setLoading(false);
                    return Swal.fire({
                        title: "¡Lo siento!",
                        text: validar.msg,
                        icon: "info",
                    }); 
                }
            }
            resp = await postEventoSeguridad({
                "evento_seguridad_id": form.evento_seguridad_id,
                "estatus_evento_id": form.estatus_evento_id,
                "apoyo_tipo_id": form.tipo_de_apoyo,
                "fecha_hora": startDate,
                "coordenadas": form.coordenadas_fin_evento,
                coordenadas_online,
                fecha_posicion_actual,
                "lugar": form.lugar_remitido,
                "observaciones": form.observaciones,
            });
        }

        if (resp.ok) {
            let re = putRegistroEventoSeguridad({
                "carpeta_investigacion": form.carpeta_investigacion ? form.carpeta_investigacion : "",
                "predenuncia": form.predenuncia,
            }, form.evento_seguridad_id);
            console.log(re);

            if (selectedFile === null) {
                resp = {
                    "ok": true,
                    "msg": "Sin archivos cargados"
                }
            } else {
                resp = await postFilesUploads(formData, resp.registro.registro_evento_id);
                if (!resp.ok) console.log("error al cargar el archivo: " + resp);
            }

            if (resp.ok && (form.estatus_evento_id !== 2 && form.estatus_evento_id !== "2" )) {
                let res = await deleteRegistroEventoSeguridad(form.evento_seguridad_id);
                if (res.ok) {
                    setLoading(false);
                    socket.emit("update_event_security");
                    Swal.fire({
                        title: "REGISTRO DE EVENTO DE ROBO",
                        text: "Finalizado correctamente",
                        showConfirmButton: false,
                        icon: "success",
                        timer: 3000
                    });
                    handleClose();
                    resetForm();
                    setSelectedFile(null);
                    await timers.setTimeout(3000, 'result').then((res) => {
                        loadData();
                    });

                } else {
                    setLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: resp.msg,
                        icon: "error",
                    });
                }

            } else if (resp.ok && (form.estatus_evento_id === 2 || form.estatus_evento_id === "2")) {
                setLoading(false);
                Swal.fire({
                    title: "REGISTRO DE EVENTO DE ROBO",
                    text: "Actualizado correctamente",
                    showConfirmButton: false,
                    icon: "success",
                    timer: 3000
                });
                onAction();
                handleClose();
                resetForm();
                setSelectedFile(null);

            } else if (!resp.ok) {
                setLoading(false);
                Swal.fire({
                    title: "Error",
                    text: resp.msg,
                    icon: "error",
                });
            }
        } else {
            setLoading(false);
            Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
            });
        }
    }

    return (
        <>
            {loading && <Spinner />}
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                fullscreen={true}
                keyboard={false}
            >
                <Modal.Header>
                    <h3>
                        {
                            eventAction === "REGISTRAR" ? (<>REGISTRO EVENTO </>) :
                                eventAction === "EDITAR" ? (<>ACTUALIZACIÓN DE EVENTO</>) : ""
                        }
                        {
                            tipo_unidad_id === 3 ? " DE MOTO" : tipo_unidad_id === 4 ? " DE AUTO" : ""
                        }
                    </h3>
                    {
                        eventAction === "REGISTRAR" && evt_seguridad_anteriores !== false ? (
                            <>
                                <p style={{ fontSize: "12px", color: "red", fontWeight: "bold" }}>
                                    Existe un evento anterior, FOLIO: {
                                        evt_seguridad_anteriores[0].folio
                                    }
                                </p>
                            </>
                        ) : ""
                    }
                    {
                        eventAction === "EDITAR" && evt_seguridad_anteriores !== false ? (
                            <>
                                <p style={{ fontSize: "12px", color: "red", fontWeight: "bold" }}>
                                    Existe un evento anterior, FOLIO: {
                                        evt_seguridad_anteriores[0].folio
                                    }
                                </p>
                            </>
                        ) : ""
                    }
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-4 card">
                            <div className="row">
                                <div className="col form-group">
                                    <label>Usuario que registra</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={
                                            eventAction === "REGISTRAR" ? user.name :
                                                form.monitorista
                                        }
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-8 card">
                            <div className="row">
                                <div className="col form-group">
                                    <label>Cliente*</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.cliente}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Evento*</label>
                                    {
                                        eventAction === "REGISTRAR" ? (
                                            <>
                                                <Select2
                                                    name="evento_id"
                                                    value={form.evento_id}
                                                    onChange={(event) => { handleChange(event) }}
                                                    options={
                                                        tipo_unidad_id === 3 ?
                                                            eventosRoboMotos.map((x) => {
                                                                return { value: x.evento_id, text: x.evento };
                                                            }) :
                                                            tipo_unidad_id === 4 ?
                                                                eventosRoboAutos.map((x) => {
                                                                    return { value: x.evento_id, text: x.evento };
                                                                }) : {}
                                                    }
                                                    className="form-control mt-2"
                                                    placeholder="Selecciona evento"
                                                />
                                            </>
                                        ) :
                                            eventAction === "EDITAR" ? (
                                                <>
                                                    <input
                                                        type="text"
                                                        className="form-control mb-3"
                                                        name="nombre_evento"
                                                        value={form.nombre_evento}
                                                        disabled
                                                    />
                                                </>
                                            ) : ""
                                    }

                                </div>
                                <div className="col form-group">
                                    <label>Estatus Evento*</label>

                                    <Select2
                                        name="estatus_evento_id"
                                        value={form.estatus_evento_id}
                                        options={
                                            tipo_unidad_id === 3 ?
                                                statusEventoMotos.map((x) => {
                                                    return { value: x.estatus_evento_id, text: x.estatus_evento };
                                                }) :
                                                tipo_unidad_id === 4 ?
                                                    statusEventoAutos.map((x) => {
                                                        return { value: x.estatus_evento_id, text: x.estatus_evento };
                                                    }) : {}
                                        }
                                        className="form-control mt-2"
                                        onChange={(event) => { handleChange(event) }}
                                        placeholder="Selecciona estatus evento"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 card ml-1">
                            <div className="row">
                                <div className="col form-group">
                                    <label>Placas*</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.placas == null ? '' : form.placas}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Serie*</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.serie == null ? '' : form.serie}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Marca*</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.marca == null ? '' : form.marca}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Color*</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.color == null ? '' : form.color}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Gestor/Usuario*</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.cliente_gestor === null ? '' : form.cliente_gestor}
                                        name="cliente_gestor"
                                        onChange={handleChange}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Teléfono*</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.cliente_gestor_telefono == null ? '' : form.cliente_gestor_telefono}
                                        name="cliente_gestor_telefono"
                                        onChange={handleChange}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        eventAction === "REGISTRAR" ? (
                            <>
                                <div className="row mt-4">
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Fecha y hora</label>
                                            <input
                                                // type="date"
                                                // className="form-control"
                                                // value={
                                                //     startDate
                                                // }
                                                type="datetime-local"
                                                name="fecha_registro"
                                                className="form-control mt-2"
                                                value={form.fecha_registro}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-10">
                                        <div className="form-group">
                                            <label>Dirección</label>
                                            <input
                                                type="text"
                                                name="vialidad"
                                                className="form-control mb-3"
                                                value={form.vialidad}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label>Coordenadas de inicio evento*</label>
                                            <input
                                                type="text"
                                                name="coordenadas_inicio_evento"
                                                className="form-control mb-3"
                                                value={form.coordenadas_inicio_evento}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label>Coordenadas de registro de evento</label>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <a
                                                    style={{
                                                        padding: "15px 20px",
                                                        position: "relative",
                                                        background: "#ffcd00",
                                                        top: "23px",
                                                        cursor: "pointer"
                                                    }}
                                                    data-toggle="tooltip"
                                                    title={
                                                        form.fecha_posicion_actual && form.fecha_posicion_actual != "" ? (
                                                            moment(form.fecha_posicion_actual).format("YYYY-MM-DD HH:mm:ss")
                                                        ) : ""
                                                    }
                                                    onClick={() => {
                                                        let array = form.posicion_actual.split(",");
                                                        window.open(
                                                            `https://www.google.es/maps?q=${array[0]},${array[1]}`
                                                        )
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faMapLocation} />
                                                </a>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="posicion_actual"
                                                value={
                                                    form.fecha_posicion_actual && form.fecha_posicion_actual != "" ? (
                                                        form.posicion_actual
                                                    ) : ""
                                                }
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label>Estado*</label>
                                            <select
                                                className="form-control mt-2"
                                                onChange={(event) => {
                                                    setForm({ ...form, estado: event.target.value });
                                                    getMunicipios(event.target.value);
                                                }}
                                                value={form.estado}
                                                defaultValue
                                            >
                                                <option value="" selected={true} disabled>
                                                    ---
                                                </option>
                                                {entidadesFederativas.map((x) => {
                                                    return (
                                                        <option value={x.entidad_federativa_id} key={x.entidad_federativa_id}>
                                                            {x.entidad_federativa}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label>Alcaldía/Municipio*</label>
                                            <Select2
                                                options={listMunicipios.map((x) => {
                                                    return { value: x.municipio_id, text: x.municipio };
                                                })}
                                                className="form-control mt-2"
                                                onChange={(event) =>
                                                    setForm({ ...form, municipio: event.target.value })
                                                }
                                                value={form.municipio}
                                                placeholder="Selecciona tu municipio"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label>Predenuncia</label>
                                            <input
                                                type="text"
                                                name="predenuncia"
                                                className="form-control mb-3"
                                                value={form.predenuncia}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label>Carpeta de investigación</label>
                                            <input
                                                type="text"
                                                name="carpeta_investigacion"
                                                className="form-control mb-3"
                                                value={form.carpeta_investigacion}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    {
                                        tipo_unidad_id === 3 ? (
                                            <div className="col-2">
                                                <div className="form-group">
                                                    <div className="form-check" style={{ margin: "35px" }}>
                                                        <input
                                                            name="activacion_as4"
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            onChange={(event) => {
                                                                setForm({ ...form, activacion_as4: event.target.checked })
                                                            }}
                                                            checked={form.activacion_as4 ? true : false}
                                                        />
                                                        <label className="form-check-label">
                                                            AS4
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : ""
                                    }
                                    <div className="col-2">
                                        <div className="form-group">
                                            <div className="form-check" style={{ margin: "35px" }}>
                                                <input
                                                    name="gps_reportando"
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    onChange={(event) => {
                                                        setForm({ ...form, gps_reportando: event.target.checked })
                                                    }}
                                                    checked={form.gps_reportando ? true : false}
                                                />
                                                <label className="form-check-label">
                                                    GPS reportando
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        tipo_unidad_id === 4 ? (
                                            <>
                                                <div className="col-2">
                                                    <div className="form-check" style={{ margin: "35px" }}>
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            onChange={(event) => {
                                                                setForm({ ...form, cctv: event.target.checked })
                                                            }}
                                                            checked={form.cctv ? true : false}
                                                        />
                                                        <label className="form-check-label">
                                                            CCTV
                                                        </label>
                                                    </div>
                                                </div>
                                            </>
                                        ) : ""
                                    }
                                    <div className="col-2">
                                        <div className="form-check" style={{ margin: "35px" }}>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={(event) => {
                                                    setForm({ ...form, paro_motor: event.target.checked })
                                                }}
                                                checked={form.paro_motor ? true : false}
                                            />
                                            <label className="form-check-label">
                                                Paro de motor
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Observaciones</label>
                                            <textarea
                                                className="form-control mb-3"
                                                rows="3"
                                                name="observaciones"
                                                value={form.observaciones}
                                                onChange={(e) => {
                                                    // handleChange();
                                                    setForm({ ...form, observaciones: e.target.value });
                                                }}
                                                spellcheck="true"
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Modus operandi</label>
                                            <textarea
                                                className="form-control mb-3"
                                                rows="3"
                                                name="modus_operandi"
                                                value={form.modus_operandi}
                                                onChange={handleChange}
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) :
                            eventAction === "EDITAR" ? (
                                <>
                                    <div className="row mt-4">
                                        <div className="col-2">
                                            <div className="form-group">
                                                <label>Fecha y hora</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={
                                                        startDate
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Fecha-hora coordenadas de registro</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="fecha_posicion_actual"
                                                    value={form.fecha_posicion_actual}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <div className="form-group">
                                                <label>Coordenadas de registro</label>
                                                <input
                                                    type="text"
                                                    name="posicion_actual"
                                                    className="form-control mb-3"
                                                    value={form.posicion_actual}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <div className="form-group">
                                                <label>Coordenadas de seguimiento</label>
                                                <input
                                                    type="text"
                                                    name="coordenadas_fin_evento"
                                                    className="form-control mb-3"
                                                    value={form.coordenadas_fin_evento}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="col form-group">
                                                <label>Corporaciones </label>
                                                <Select
                                                    name="tipo_de_apoyo"
                                                    options={tipoApoyo.map((x) => {
                                                        return { value: x.apoyo_tipo_id, label: x.apoyo_tipo };
                                                    })}
                                                    isMulti
                                                    className="form-control mt-2"
                                                    classNamePrefix={"select"}
                                                    value={form.tipo_de_apoyo}
                                                    onChange={(event) => {

                                                        let aux = [];
                                                        event.forEach((label) => {
                                                            aux.push(label);
                                                        });

                                                        setForm({ ...form, tipo_de_apoyo: aux })
                                                    }}
                                                    placeholder="Selecciona el tipo de apoyo"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-5">
                                            <div className="form-group">
                                                <label>Lugar donde será remitida</label>
                                                <input
                                                    type="text"
                                                    name="lugar_remitido"
                                                    className="form-control mb-3"
                                                    value={form.lugar_remitido}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <div className="form-group">
                                                <label>Cargar archivo</label>

                                                <input
                                                    style={{ marginTop: "8px" }}
                                                    name="cargar_archivo"
                                                    className="form-control mb-3"
                                                    type="file"
                                                    accept=".xlsx,.xls, .csv/*,.doc, .docx, .pdf, image/*, video/mp4"
                                                    onChange={handleFileUpload}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <div className="form-group">
                                                <label>Carpeta de investigación:</label>
                                                <input
                                                    type="text"
                                                    name="carpeta_investigacion"
                                                    className="form-control mb-3"
                                                    value={form.carpeta_investigacion}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Predenuncia:</label>
                                                <input
                                                    type="text"
                                                    name="predenuncia"
                                                    className="form-control mb-3"
                                                    value={form.predenuncia}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label>Observaciones</label>
                                                <textarea
                                                    className="form-control mb-3"
                                                    rows="3"
                                                    name="observaciones"
                                                    value={form.observaciones}
                                                    onChange={handleChange}
                                                >
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : ""
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        onClick={() => (
                            eventAction === "REGISTRAR" ? registrarEventoRobo() : eventAction === "EDITAR" ? actualizarEventoRobo() : ""
                        )}
                    >
                        {
                            eventAction === "REGISTRAR" ? "REGISTRAR" : eventAction === "EDITAR" ? "ACTUALIZAR" : ""
                        }
                    </Button>
                    <Button variant="secondary" onClick={() => (handleClose(), resetForm(), onAction())}>
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}